/* src/app/modules/ct-status/components/cts-gantry-functional-unit-grid-legend/cts-gantry-functional-unit-grid-legend.component.scss */
:host {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 0.5rem;
}
sh-text {
  width: fit-content;
}
.legend-bulet-label {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.5rem;
  align-items: center;
}
.legend-bulet-label .cts-step-legend {
  width: 0.5rem;
  height: 0.5rem;
}
/*# sourceMappingURL=cts-gantry-functional-unit-grid-legend.component.css.map */
